import React from 'react';
import { colors as theme } from '../../theme';

const colors = {
  bg: theme.bg,
  surface2: theme.surface1,
  surface3: theme.surface3,
  border: 'rgba(255, 255, 255, 0.08)',
  text: theme.text,
  textMuted: theme.textMuted,
  accent: theme.gold,
};

const typography = {
  h3: { fontSize: '18px', fontWeight: '600', lineHeight: '1.4' },
  body: { fontSize: '15px', fontWeight: '400', lineHeight: '1.6' },
  small: { fontSize: '13px', fontWeight: '500', lineHeight: '1.5' },
  tiny: { fontSize: '11px', fontWeight: '600', letterSpacing: '0.5px' },
};

const PRBadges = ({ prs }) => {
  if (!prs || prs.length === 0) {
    return (
      <div style={styles.container}>
        <h3 style={{ ...typography.h3, color: colors.text, margin: '0 0 12px 0' }}>
          Personal Records
        </h3>
        <p style={{ ...typography.body, color: colors.textMuted, textAlign: 'center', padding: '20px 0' }}>
          Keep pushing for your next PR! 💪
        </p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <style>{cssAnimations}</style>
      <h3 style={{ ...typography.h3, color: colors.text, margin: '0 0 12px 0' }}>
        Personal Records 🎉
      </h3>
      <div style={styles.badgesContainer}>
        {prs.slice(0, 3).map((pr, index) => (
          <div key={index} style={styles.prBadge}>
            <div style={styles.prHeader}>
              <span style={{ ...typography.small, color: colors.accent, fontWeight: '700' }}>
                {pr.exerciseName}
              </span>
              {pr.isFirstTime && (
                <span style={styles.firstTimeTag}>FIRST TIME!</span>
              )}
            </div>
            <div style={styles.prStats}>
              <span style={{ ...typography.h3, color: colors.text }}>
                {pr.weight}kg × {pr.reps}
              </span>
              {/* Name the rep range. Records are tracked per range, so "best at 11-15 reps" is
                  what was actually achieved — without it a lighter, higher-rep set reads as if
                  it beat a heavier one, which is how the old volume-ranked version misled. */}
              <span style={{ ...typography.small, color: colors.textMuted }}>
                {pr.repRange ? `Best at ${pr.repRange} reps` : 'Personal best'}
              </span>
              {pr.improvement && (
                <span style={{ ...typography.small, color: colors.accent }}>
                  {pr.improvement} on your previous best
                </span>
              )}
            </div>
          </div>
        ))}
        {prs.length > 3 && (
          <p style={{ ...typography.small, color: colors.textMuted, marginTop: '8px', textAlign: 'center' }}>
            +{prs.length - 3} more personal {prs.length - 3 === 1 ? 'record' : 'records'}!
          </p>
        )}
      </div>
    </div>
  );
};

const cssAnimations = `
  @keyframes prGlow {
    0%, 100% {
      box-shadow: 0 0 10px rgba(212, 175, 55, 0.3);
    }
    50% {
      box-shadow: 0 0 20px rgba(212, 175, 55, 0.6);
    }
  }
`;

const styles = {
  container: {
    padding: '20px',
    backgroundColor: colors.surface2,
    borderRadius: '14px',
    border: `1px solid ${colors.border}`,
    marginBottom: '24px',
  },
  badgesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  prBadge: {
    padding: '16px',
    backgroundColor: colors.surface3,
    borderRadius: '14px',
    border: `2px solid ${colors.accent}`,
    animation: 'prGlow 2s ease-in-out infinite',
  },
  prHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  firstTimeTag: {
    padding: '4px 8px',
    backgroundColor: colors.accent,
    color: colors.bg,
    borderRadius: '8px',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.5px',
  },
  prStats: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
};

export default PRBadges;
